/* Tâches « Contrat énergie » (table crm_tasks) : offre du fournisseur partenaire et intérêt pour un achat groupé
 * (fonction member-contract), fin d'un contrat fournisseur dans les 3 mois (tâche planifiée crm_contract_end_tasks). */
import { supabase } from '../../lib/supabase';

export type MemberTaskKind = 'partner_offer' | 'group_purchase' | 'contract_end';
export interface MemberTask {
  id: string;
  created_at: string;
  kind: MemberTaskKind;
  badge: string;
  title: string;
  details: {
    email?: string; message?: string; lang?: string; sites?: { id: string; name: string; ean?: string | null }[];
    /** Fin de contrat : prélèvement ou injection, fournisseur, date de fin (AAAA-MM-JJ). */
    contract?: 'offtake' | 'injection'; supplier?: string | null; end_date?: string;
  };
  participant_ids: string[];
  contact_id: string | null;
  done_at: string | null;
}

export const TASK_BADGES: Record<string, string> = { contrat_energie: 'Contrat énergie' };
export const TASK_KIND_LABELS: Record<MemberTaskKind, string> = {
  partner_offer: 'Demande d’offre fournisseur partenaire',
  group_purchase: 'Intérêt pour un achat groupé',
  contract_end: 'Fin de contrat fournisseur dans moins de 3 mois',
};

/** Demandes ouvertes, les plus anciennes d'abord. Table absente (migration pas encore exécutée) : liste vide. */
export async function fetchOpenMemberTasks(): Promise<MemberTask[]> {
  const { data, error } = await supabase.from('crm_tasks').select('*').is('done_at', null).order('created_at', { ascending: true });
  if (error) {
    if (/crm_tasks/.test(error.message ?? '')) return [];
    throw error;
  }
  return (data ?? []) as MemberTask[];
}

export async function setMemberTaskDone(id: string, done: boolean): Promise<void> {
  const { data: { session } } = await supabase.auth.getSession();
  const { error } = await supabase.from('crm_tasks')
    .update(done ? { done_at: new Date().toISOString(), done_by: session?.user?.email ?? null } : { done_at: null, done_by: null })
    .eq('id', id);
  if (error) throw error;
}
